const styles = (theme) => ({
  page: {
    width: "100%",
    padding: "16px",
  },
  mainPaper: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "20px",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  headerTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  title: {
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    maxWidth: "760px",
  },
  infoAlert: {
    borderRadius: "12px",
    width: "fit-content",
    maxWidth: "100%",
  },
  tabs: {
    minHeight: "40px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTabs-indicator": {
      height: "3px",
      borderRadius: "3px 3px 0 0",
    },
  },
  tab: {
    minHeight: "40px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.85rem",
    gap: 0.5,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1.5,
  },
  searchField: {
    minWidth: "260px",
    flex: { xs: "1 1 100%", sm: "0 1 320px" },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 2,
  },
  loadingState: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    padding: "40px 0",
  },
  emptyTitle: {
    fontWeight: 600,
  },
  emptyDescription: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
  payloadAccordion: {
    borderRadius: "16px",
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
    "&:before": { display: "none" },
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  payloadSummary: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  payloadSummaryText: {
    fontWeight: 600,
    fontSize: "0.9rem",
  },
  payloadHint: {
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
    mb: 1.5,
  },
  payloadGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 1.5,
  },
  payloadLabel: {
    fontWeight: 600,
    fontSize: "0.78rem",
    fontFamily: "monospace",
    mb: 0.5,
  },
  payloadCode: {
    margin: 0,
    fontFamily: "monospace",
    fontSize: "0.72rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    maxHeight: "220px",
    overflowY: "auto",
    padding: "10px",
    borderRadius: "10px",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
});

export default styles;
